import ComingSoon from "../components/comingSoon";
import { MdPayment } from "react-icons/md";
import EscrowRequestList from "views/TransactionManagement/EscrowRequest";

const Escrow = [
  {
    path: "/escrow-request",
    name: "Escrow Request",
    icon: <MdPayment />,
    component: <EscrowRequestList />,
    layout: "/admin",
    showInSidebar: true
  }
];

export default Escrow;
